import config from "@/libs/config";
import Link from "next/link";
import { linkStyle } from "@/styles/sharedStyle";
import { css } from "@emotion/react";

export const ConnectBoardTopLink = () => {
  return (
    <div css={linkWrapper}>
      <Link href="/connect-biz/redirect-top">
        <span css={linkStyle}>{config.CONNECT_BOARD_DISPLAY_NAME} トップ</span>
      </Link>
    </div>
  );
};

// place the link in the middle of the page
const linkWrapper = css({
  display: "flex",
  justifyContent: "center",
  marginBottom: "16px",
  marginTop: "160px",
});
